// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dc88fc59","977":"751ceffc"}[chunkId] + ".chunk.js";
};